import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'locationEnabled'
})
export class LocationEnabledPipe implements PipeTransform {

  transform(value: number, type: 'cabinet' | 'distance'): boolean {

    if (value === null || value === undefined) return false;

    switch (type) {
      case 'cabinet':
        return value === 0 || value === 2;

      case 'distance':
        return value === 1 || value === 2;

      default:
        return false;
    }
  }
}